import tw from "tailwind-styled-components"


export const HomeContainer = tw.div `
container
mx-auto 
px-4
sm:px-6  
`